module.exports = __webpack_public_path__ + "images/select-view-dropdown-69205e80.svg";